import { useFormState } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { INVALID_EMAIL, INVALID_PASSWORD, hasError, messageError } from '../../../utils/session/authErros'
import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'
import { useSubdomain } from '../../../utils/contexts/UrlProvider'
import Button from '../../../packages/kiti/components/actions/Button'
import Input from '../../../components/form/Input'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'
import useLoginRequest from './_requests/loginRequest'
import ConditionalLink from '../../../packages/kiti/components/actions/ConditionalLink'
import { useQueryParams } from '../../../utils/contexts/UrlProvider'
import { useHelpActions } from '../../../utils/contexts/HelpProvider'

const LoginForm = () => {
  const { t } = useTranslation('session')
  const colors = useColors()
  const workspace = useSubdomain()
  const SSO_CLIENTS = ['portosaude']
  const enableDefaultLogin = useQueryParams().enableDefaultLogin === 'true'
  const useDefaultLogin = !SSO_CLIENTS.includes(workspace) || !!enableDefaultLogin
  const [form, handleChange] = useFormState({
    email: '',
    password: '',
    workspace
  })

  const [handleRequest, { loading, error }] = useLoginRequest(form, handleChange)
  const { initChat } = useHelpActions()

  initChat({})

  return (
    <form onSubmit={handleRequest}>
      <Title size="h3">{t('welcome')}</Title>

      <Separator weight={4} />
      {useDefaultLogin && (
        <>
          <Input
            type="email"
            placeholder={t('email')}
            value={form.email}
            onChange={handleChange('email')}
            errorBorder={hasError(error, INVALID_EMAIL)}
            defaultRadialBorder={true}
          />
          <Separator weight={3} />
          <Input
            type="password"
            placeholder={t('password')}
            value={form.password}
            onChange={handleChange('password')}
            errorBorder={hasError(error, INVALID_PASSWORD)}
            defaultRadialBorder={true}
          />
          <Separator weight={4} />
          <Text color={colors.red}>{messageError(error)}</Text>
          <Separator weight={2} />
          <Button type="submit" fullWidth loading={loading} color={colors.primary}>
            {t('submit')}
          </Button>
          <Separator />
        </>
      )}

      {!useDefaultLogin && (
        <>
          <Separator weight={2} />
          <ConditionalLink
            width={'100%'}
            path={`https://api.btime.io/new/sso/auth/signin/portoseguroprodext_idp?target_url=https%3A%2F%2Fportosaude.btime.io%3Forigin%3Dweb`}
            useNewTab
          >
            <Button fullWidth loading={false} color={colors.primary}>
              {t('ssoLogin')}
            </Button>
          </ConditionalLink>
          <Separator weight={4} />
        </>
      )}
    </form>
  )
}

export default LoginForm
